<template>
    <div class="grid grid-cols-12" :style="{ backgroundColor: backgroundColor }">
        <div class="lg:ml-[calc((100vw_-_1024px)_/_2)] mx-auto xl:px-0 px-4 lg:py-20 py-10 lg:col-span-7 col-span-12 flex flex-col justify-center lg:order-1 order-2">
            <h3 class="mx-auto text-2xl text-center md:text-3xl font-ww-bold lg:mx-0 lg:max-w-sm xl:text-4xl md:text-left" v-html="mainHeading">
            </h3>

            <div class="grid grid-cols-12 gap-x-6 gap-y-8 mt-10 md:gap-x-12">
                <div v-for="(feature, index) in features" :key="index" class="col-span-12 sm:col-span-6">
                    <div>
                        <nuxt-img class="w-16 md:w-20 xs-max:mx-auto" :src="feature.image" :alt="feature.alt" width="84" height="84"
                            format="webp" loading="lazy" sizes="xs:84px sm:84px md:84px lg:84px xl:84px" />

                        <div class="sm:text-base text-sm xl:!leading-6 !leading-5 xl:text-lg font-ww-regular max-w-64 mt-4 xs-max:mx-auto">
                            <strong>{{ feature.title }}:</strong> {{ feature.description }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="order-1 col-span-12 lg:col-span-5 lg:order-2 lg:max-h-full max-h-[600px]">
            <nuxt-img 
                            class="object-cover mx-auto h-full" 
                            :src="rightImageSrc"
                            :alt="rightImageAlt"
                            width="794"
                            height="948"
                            format="webp"
                            loading="lazy"
                            sizes="xs:330px sm:440px md:751px lg:1008px xl:493px"
                           />
        </div>
    </div>
</template>

<script setup>
defineProps({
  backgroundColor: {
    type: String,
    default: '#FCF7F1'
  },
  mainHeading: {
    type: String,
    default: 'Goodbye Jitters.<br>Hello Focused Flow.'
  },
  features: {
    type: Array,
    default: () => [
      {
        image: "/assets/images/crash-1.svg",
        alt: "drink mindflow 1",
        title: "No Crash, No Fog, No Anxiety",
        description: "Say goodbye to the usual caffeine chaos. Stay steady, sharp, and in control."
      },
      {
        image: "/assets/images/mental-1.svg",
        alt: "drink mindflow 2",
        title: "Sustained Mental Energy",
        description: "No sugar spikes, no artificial stimulation. Just long-lasting clarity and calm power from your first sip to your final task."
      },
      {
        image: "/assets/images/sharper-1.svg",
        alt: "drink mindflow 3",
        title: "Sharper Focus and Alertness",
        description: "Lock in. Tune out distractions. Tackle your to-do list with total mental clarity."
      },
      {
        image: "/assets/images/productivity-1.svg",
        alt: "drink mindflow 4",
        title: "Productivity on Demand",
        description: "Whether you're writing, building, leading, or creating—get more done in less time."
      }
    ]
  },
  rightImageSrc: {
    type: String,
    default: '/assets/images/right-woman.jpg'
  },
  rightImageAlt: {
    type: String,
    default: 'woman with focused energy'
  }
})

defineBuilderComponent({
    friendlyName: 'Grid Feature Icons With Image',
    canHaveChildren: false,
    inputs: [
        {
            name: 'backgroundColor',
            type: 'color',
            defaultValue: '#FCF7F1'
        },
        {
            name: 'mainHeading',
            type: 'richText',
            defaultValue: 'Goodbye Jitters.<br>Hello Focused Flow.'
        },
        {
            name: 'features',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
                    defaultValue: ''
                },
                {
                    name: 'alt',
                    type: 'text',
                    defaultValue: ''
                },
                {
                    name: 'title',
                    type: 'text',
                    defaultValue: ''
                },
                {
                    name: 'description',
                    type: 'richText',
                    defaultValue: ''
                }
            ],
            defaultValue: [
                {
                    image: "/assets/images/crash-1.svg",
                    alt: "drink mindflow 1",
                    title: "No Crash, No Fog, No Anxiety",
                    description: "Say goodbye to the usual caffeine chaos. Stay steady, sharp, and in control."
                },
                {
                    image: "/assets/images/mental-1.svg",
                    alt: "drink mindflow 2",
                    title: "Sustained Mental Energy",
                    description: "No sugar spikes, no artificial stimulation. Just long-lasting clarity and calm power from your first sip to your final task."
                },
                {
                    image: "/assets/images/sharper-1.svg",
                    alt: "drink mindflow 3",
                    title: "Sharper Focus and Alertness",
                    description: "Lock in. Tune out distractions. Tackle your to-do list with total mental clarity."
                },
                {
                    image: "/assets/images/productivity-1.svg",
                    alt: "drink mindflow 4",
                    title: "Productivity on Demand",
                    description: "Whether you're writing, building, leading, or creating—get more done in less time."
                }
            ]
        },
        {
            name: 'rightImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/right-woman.jpg'
        },
        {
            name: 'rightImageAlt',
            type: 'text',
            defaultValue: 'woman with focused energy'
        }
    ]
})
</script>